import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    contacts: [],
    req_contacts_loading: false,
    req_contacts_error: null,

    contact: null,
    req_contact_loading: false,
    req_contact_error: null,

    selectedContact: null,

    connection: null,
    req_connection_loading: false,
    req_connection_error: null,
}

const xeroSlice = createSlice({
    name: 'xero',
    initialState,
    reducers: {
        Request_Contacts(state) {
            state.req_contacts_loading = true;
            state.req_contacts_error = null;

            state.selectedContact = null;
            state.contact = null;

        },
        Request_Contacts_Response(state, action) {
            state.req_contacts_loading = false;
            state.contacts = action.payload;
        },
        Request_Contacts_Error(state, action) {
            state.req_contacts_loading = false;
            state.req_contacts_error = action.payload;
        },
        Select_Contact(state, action) {
            state.selectedContact = action.payload;
            state.contact = null;
        },
        Request_Contact(state) {
            state.contact = null;
            state.req_contact_loading = true;
            state.req_contact_error = null;
        },
        Request_Contact_Response(state, action) {
            state.req_contact_loading = false;
            state.contact = action.payload;
            state.req_contact_error = null;
        },
        Request_Contact_Error(state, action) {
            state.req_contact_loading = false;
            state.req_contact_error = action.payload;
        },
        Request_Connection(state) {
            state.req_connection_loading = true;
            state.req_connection_error = null;
        },
        Request_Connection_Response(state, action) {
            state.req_connection_loading = false;
            state.connection = action.payload;   // payload is the safe summary from /connection
        },
        Request_Connection_Error(state, action) {
            state.req_connection_loading = false;
            state.req_connection_error = action.payload || 'Failed to load Xero connection';
            state.connection = null;
        },

        // Optional: clear connection (e.g., on logout)
        Clear_Connection(state) {
            state.connection = null;
            state.req_connection_loading = false;
            state.req_connection_error = null;
        },
    }
})

export default xeroSlice.reducer;
export const xeroActions = xeroSlice.actions;